/**
 * currentOrganizationId constants
 */
export const SET_CURRENT_ORGANIZATION_ID = 'SET_CURRENT_ORGANIZATION_ID';
